import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FeedbackManagerSubComponent } from '../admin/sub-admin/feedback-manager-sub/feedback-manager-sub.component';
import { AddFeedbackManagerSubComponent } from '../admin/sub-admin/add-feedback-manager-sub/add-feedback-manager-sub.component';
import { NewPurchaseUpgradesComponent } from '../admin/new-purchase-upgrades/new-purchase-upgrades.component';
import { NewReviewsComponent } from '../admin/new-reviews/new-reviews.component';
import { NewFeedbackUrlComponent } from '../admin/new-feedback-url/new-feedback-url.component';
import { GoogleReviewsComponent } from '../admin/google-reviews/google-reviews.component';
import { InstagramReviewsComponent } from '../admin/instagram-reviews/instagram-reviews.component';
import { TwitterReviewsComponent } from '../admin/twitter-reviews/twitter-reviews.component';
import { OurFeaturesFirstComponent } from '../admin/our-features-first/our-features-first.component';
import { OurFeaturesSecondComponent } from '../admin/our-features-second/our-features-second.component';
import { OurFeaturesThirdComponent } from '../admin/our-features-third/our-features-third.component';
import { NewEditProfileComponent } from '../admin/new-edit-profile/new-edit-profile.component';
import { NewSubAdminsComponent } from '../admin/new-sub-admins/new-sub-admins.component';
import { NewSubAdminsSubscription } from '../admin/new-sub-admins-subscription/new-sub-admins.component';
import { NewSubAdminsTransactions } from '../admin/new-sub-admins-transactions/new-sub-admins.component';
import { NewSubAdminsDiamondTransactions } from '../admin/new-sub-admins-diamond-transactions/new-sub-admins.component';
import { NewSubAdminsRentalAuth } from '../admin/new-sub-admins-rental-auth/new-sub-admins.component';
import { NewSubAdminsUsersAuth } from '../admin/new-sub-admins-users-auth/new-sub-admins.component';
import { NewUpdateProfileComponent } from '../admin/new-update-profile/new-update-profile.component';
import { NewPricesAndPackagesComponent } from '../admin/new-prices-and-packages/new-prices-and-packages.component';
import { NewHelpCenterComponent } from '../admin/new-help-center/new-help-center.component';
import { NewOurFeaturesComponent } from '../admin/new-our-features/new-our-features.component';
import { ReviewPendingCompleteComponent } from '../admin/review-pending-complete/review-pending-complete.component';
import { NewReviewInfoComponent } from '../admin/new-review-info/new-review-info.component';
import { NewNameComponent } from '../admin/new-name/new-name.component';
import { MassMessagingComponent } from '../admin/mass-messaging/mass-messaging.component';
import { AddProductComponent } from '../admin/sub-admin/add-product/add-product.component';
import { BookingsComponent } from '../admin/bookings/bookings.component';
import { AdminMembersAnalyticsComponent } from '../admin/admin-members-analytics/admin-members-analytics.component';
import { AdminManageChatAIComponent } from '../admin/admin-manage-chat-ai/admin-manage-chat-ai.component';
import { AdminManageSurveyComponent } from '../admin/admin-manage-survey/admin-manage-survey.component';
import { ManageBrandsComponent } from '../admin/admin-market/manage-brands/manage-brands.component';
import { AdminForumCategoriesComponent } from '../admin/admin-forum-categories/admin-forum-categories.component';
import { AdminForumPollingComponent } from '../admin/admin-forum-polling/admin-forum-polling.component';
import { AdminForumGiveawayComponent } from '../admin/admin-forum-giveaway/admin-forum-giveaway.component';
import { AdminForumGiveawayDetailComponent } from '../admin/admin-forum-giveaway/forum-giveaway-detail/forum-giveaway-detail.component';
import { SuperAdminComponent } from '../admin/super-admin/super-admin.component';
import { QuestsComponent } from '../admin/super-admin/quests/quests.component';
import { MapSearchComponent } from '../admin/map-search/map-search.component';
import { AdminMarketComponent } from '../admin/admin-market/admin-market.component';
import { AdminMarketBlogComponent } from '../admin/admin-market-blog/admin-market-blog.component';
import { CampaignComponent } from '../admin/campaign/campaign.component';
import { SubadminOrdersComponent } from '../admin/subadmin-orders/subadmin-orders.component';
import { SubAdminVoucherComponent } from '../admin/sub-admin/voucher-cashback/voucher/voucher.component';
import { SubAdminCashbackComponent } from '../admin/sub-admin/voucher-cashback/cashback/cashback.component';
import { SubAdminNewsComponent } from '../admin/sub-admin/voucher-cashback/news/news.component';
import { SubAdminGalleryComponent } from '../admin/sub-admin/voucher-cashback/gallery/gallery.component';
import { ShopSummaryComponent } from '../admin/shop-summary/shop-summary.component';
import { ManageMemberRolesComponent } from '../admin/manage-member-roles/manage-member-roles.component';
import { ManualReviewsTwoComponent } from '../admin/manual-reviews-two/manual-reviews-two.component';
import { ManualReviewsThreeComponent } from '../admin/manual-reviews-three/manual-reviews-three.component';
import { ReviewPendingCompleteAdditionalComponent } from '../admin/review-pending-complete-additional/review-pending-complete-additional.component';
import { NewDashboardComponent } from './new-dashboard/new-dashboard.component';
import { MemberSurveyComponent } from './admin-market/member-survey/member-survey.component';
import { ActivityLogComponent } from './sub-admin/activity-log/activity-log.component';
import { PaymentComponent } from './payment/payment.component';
import { FaqComponent } from './faq/faq.component';
import { BizTelegramComponent } from './biz-telegram/biz-telegram.component';
import { BizMessagesComponent } from './biz-messages/biz-messages.component';
import { AdminAdComponent } from './admin-ad/admin-ad.component';
import { AdminStatsComponent } from './admin-stats/admin-stats.component';

const routes: Routes = [
  {
    path: 'new-dashboard',
    component: NewDashboardComponent,
  },
  {
    path: 'payment',
    component: PaymentComponent,
  },
  {
    path: 'our-features',
    component: NewOurFeaturesComponent,
  },
  {
    path: 'prices-and-packages',
    component: NewPricesAndPackagesComponent,
  },
  {
    path: 'add-feedback-manager-sub',
    component: AddFeedbackManagerSubComponent,
  },
  {
    path: 'review-info',
    component: NewReviewInfoComponent,
  },
  {
    path: 'addName',
    component: NewNameComponent,
  },
  {
    path: 'mapSearch',
    component: MapSearchComponent,
  },
  {
    path: 'shop-summary',
    component: ShopSummaryComponent,
  },
  {
    path: 'campaigns',
    component: CampaignComponent,
  },
  {
    path: 'edit-profile',
    component: NewEditProfileComponent,
  },
  {
    path: 'feedback-url/:id',
    component: NewFeedbackUrlComponent,
  },
  {
    path: 'review-list/:id',
    component: NewReviewsComponent,
  },
  {
    path: 'google-reviews',
    component: NewPurchaseUpgradesComponent,
  },
  {
    path: 'purchase-upgrades',
    component: GoogleReviewsComponent,
  },
  {
    path: 'google-business',
    component: InstagramReviewsComponent,
  },
  {
    path: 'map-booster',
    component: TwitterReviewsComponent,
  },
  {
    path: 'qr-review-upgrade-features',
    component: OurFeaturesFirstComponent,
  },
  {
    path: 'sticker-design',
    component: OurFeaturesSecondComponent,
  },
  {
    path: 'feedback-manager-features',
    component: OurFeaturesThirdComponent,
  },

  {
    path: 'feedback-manager-sub',
    component: FeedbackManagerSubComponent,
  },
  {
    path: 'shop',
    component: AddProductComponent,
  },
  {
    path: 'manage-market',
    component: AdminMarketComponent,
  },
  {
    path: 'manage-faq',
    component: FaqComponent,
  },
  {
    path: 'manage-member-roles',
    component: ManageMemberRolesComponent,
  },
  {
    path: 'manage-member-survey',
    component: MemberSurveyComponent,
  },
  {
    path: 'manage-market-blog',
    component: AdminMarketBlogComponent,
  },
  {
    path: 'orders',
    component: SubadminOrdersComponent,
  },
  {
    path: 'activity-log',
    component: ActivityLogComponent,
  },
  {
    path: 'voucher',
    component: SubAdminVoucherComponent,
  },
  {
    path: 'stats',
    component: AdminStatsComponent,
  },
  {
    path: 'ads',
    component: AdminAdComponent
  },
  {
    path: 'cashback',
    component: SubAdminCashbackComponent,
  },
  {
    path: 'news',
    component: SubAdminNewsComponent,
  },
  {
    path: 'gallery',
    component: SubAdminGalleryComponent,
  },
  {
    path: 'bookings',
    component: BookingsComponent,
  },
  {
    path: 'biz-telegram',
    component: BizTelegramComponent,
  },
  {
    path: 'biz-messages',
    component: BizMessagesComponent
  },

  {
    path: 'members-analytics',
    component: AdminMembersAnalyticsComponent,
  },
  {
    path: 'manage-chat-ai',
    component: AdminManageChatAIComponent,
  },
  {
    path: 'manage-survey',
    component: AdminManageSurveyComponent,
  },
  {
    path: 'manage-brands',
    component: ManageBrandsComponent,
  },
  {
    path: 'super-admin',
    component: SuperAdminComponent,
  },
  {
    path: 'quests',
    component: QuestsComponent,
  },
  {
    path: 'forum-categories',
    component: AdminForumCategoriesComponent,
  },
  {
    path: 'forum-polling',
    component: AdminForumPollingComponent,
  },
  {
    path: 'forum-giveaway',
    component: AdminForumGiveawayComponent,
  },
  {
    path: 'forum-giveaway/:id',
    component: AdminForumGiveawayDetailComponent,
  },
  {
    path: 'help-centre',
    component: NewHelpCenterComponent,
  },

  {
    path: 'update-profile/:id',
    component: NewUpdateProfileComponent,
  },
  {
    path: 'sub-admins',
    component: NewSubAdminsComponent,
  },
  {
    path: 'mass-messaging',
    component: MassMessagingComponent,
  },
  {
    path: 'sub-trans',
    component: NewSubAdminsSubscription,
  },
  {
    path: 'transactions',
    component: NewSubAdminsTransactions,
  },
  {
    path: 'diamond_transactions',
    component: NewSubAdminsDiamondTransactions,
  },
  {
    path: 'rental_auth',
    component: NewSubAdminsRentalAuth,
  },
  {
    path: 'users_auth',
    component: NewSubAdminsUsersAuth,
  },
  {
    path: 'review_pending_complete',
    component: ReviewPendingCompleteComponent,
  },
  {
    path: 'review_pending_complete_additional',
    component: ReviewPendingCompleteAdditionalComponent,
  },
  {
    path: 'manual-review-2',
    component: ManualReviewsTwoComponent,
  },
  {
    path: 'manual-review-3',
    component: ManualReviewsThreeComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdminRoutingModule { }
